import styled from "styled-components";

export const StyledClock = styled.p`
  font-size: 12px;
  text-align: right;
`;
